import React from "react";
import styles from "./styles.module.scss";
import { cls } from "app/utils";

interface Props {
  buttonText: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  isActive: boolean;
  buttonStyle?: string;
}

const ButtonSimple = ({ buttonText, onClick, isActive, buttonStyle }: Props) => {
  return (
    <button
      className={cls(styles.button, { [styles.active_button]: isActive }, buttonStyle)}
      onClick={onClick}
    >
      <span className={cls(styles.text, { [styles.active_text]: isActive })}>
        {buttonText}
      </span>
    </button>
  );
};

export default ButtonSimple;
